"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { useEditorState } from "@tiptap/react";
import { LuHeading1, LuHeading2, LuHeading3, LuType } from "react-icons/lu";
import { Button } from "@/components/ui";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cx } from "@/lib/tailwind-utils";
const HEADING_OPTIONS = [{
  label: "Text",
  icon: LuType,
  level: null
}, {
  label: "Heading 1",
  icon: LuHeading1,
  level: 1
}, {
  label: "Heading 2",
  icon: LuHeading2,
  level: 2
}, {
  label: "Heading 3",
  icon: LuHeading3,
  level: 3
}] as const;
export function HeadingDropdown() {
  const $ = _c(14);
  const {
    editor
  } = useEmailComposer();
  let t0;
  if ($[0] !== editor) {
    t0 = {
      editor,
      selector: _temp
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeLevel = useEditorState(t0);
  let t1;
  if ($[2] !== activeLevel) {
    t1 = HEADING_OPTIONS.find(o => o.level === activeLevel) ?? HEADING_OPTIONS[0];
    $[2] = activeLevel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const active = t1;
  const ActiveIcon = active.icon;
  let t2;
  if ($[4] !== ActiveIcon) {
    t2 = <PopoverTrigger asChild={true}><Button type="button" variant="ghost" size="icon-sm" tooltip="Block type"><ActiveIcon size={16} /></Button></PopoverTrigger>;
    $[4] = ActiveIcon;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== activeLevel || $[7] !== editor) {
    t3 = HEADING_OPTIONS.map(opt => {
      const Icon = opt.icon;
      const isActive = opt.level === activeLevel;
      return <button key={opt.label} type="button" className={cx("flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-body transition-colors", isActive ? "bg-primary/10 text-foreground" : "text-foreground hover:bg-hover")} onMouseDown={_temp3} onClick={() => {
        if (!editor) {
          return;
        }
        if (opt.level) {
          editor.chain().focus().setNode("emailHeading", {
            level: opt.level
          }).run();
        } else {
          editor.chain().focus().setNode("emailParagraph").run();
        }
        trackEmailComposerAction("heading_changed", "toolbar", {
          level: opt.level ?? "paragraph"
        });
      }}><Icon size={15} className="text-foreground-secondary" /><span>{opt.label}</span></button>;
    });
    $[6] = activeLevel;
    $[7] = editor;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <PopoverContent align="start" sideOffset={6} className="w-36 p-1" onOpenAutoFocus={_temp2}>{t3}</PopoverContent>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <Popover>{t2}{t4}</Popover>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp3(e_0) {
  return e_0.preventDefault();
}
function _temp2(e) {
  return e.preventDefault();
}
function _temp(ctx) {
  if (!ctx.editor) {
    return null;
  }
  for (const lvl of [1, 2, 3] as const) {
    if (ctx.editor.isActive("emailHeading", {
      level: lvl
    })) {
      return lvl;
    }
  }
  return null;
}